module.exports = __webpack_public_path__ + "img/探照灯.67f7e01a.png";